
<div class="tasks-container">
  <div class="tasks-title-row">
    <div class="tasks-title">{{ pastDueCount }} Past Due Tasks - {{ pastDueCreatorFacingCount }} are Creator Facing</div>
  </div>
  <div class="tasks-header-row">
    <div class="header-flag-cell">
      <span>$</span>
      <input [(ngModel)]="showInvoiceTasks" (ngModelChange)="setFilteredTasks()" type="checkbox" />
    </div>
    <div class="header-flag-cell">
      <span>CF</span>
      <input [(ngModel)]="showCreatorFacingOnly" (ngModelChange)="setFilteredTasks()" type="checkbox" />
    </div>
    <div class="header-controls">
      <div class="header-item no-break">
        <span>Agent</span>
        <select [(ngModel)]="agentFilter" (ngModelChange)="setFilteredTasks()">
          <option *ngFor="let agent of agents" [value]="agent">{{ resolveFirstName(agent) }}</option>
        </select>
      </div>
      <div class="header-item no-break">
        <span>Coord</span>
        <select [(ngModel)]="coordinatorFilter" (ngModelChange)="setFilteredTasks()">
          <option *ngFor="let coord of coordinators" [value]="coord">{{ resolveFirstName(coord) }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="task-items-container" *ngIf="sortedFilteredTasks.length > 0" >
    <ng-container *ngFor="let task of sortedFilteredTasks">
      <app-task [task]="task" (taskChanged)="onTaskChanged()"></app-task>
    </ng-container>
  </div>
</div>
